import { render, staticRenderFns } from "./DonutClassificacao.vue?vue&type=template&id=489e51ed&scoped=true"
import script from "./DonutClassificacao.vue?vue&type=script&lang=js"
export * from "./DonutClassificacao.vue?vue&type=script&lang=js"
import style0 from "./DonutClassificacao.vue?vue&type=style&index=0&id=489e51ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e51ed",
  null
  
)

export default component.exports